// Site configuration
export const siteConfig = {
  siteTitle: "J&B Lodge",
  propertyArea: "Underberg",
  siteDescription: "J&B Lodge, self-catering accommodation in Underberg",
  tabTitle: "J&B Lodge, self-catering accommodation in Underberg",
  ctaButtonText: "Book now",
  propertyBBID: 18993,
  // SEO Configuration
  siteUrl: "https://jnblodge.co.za",
  defaultDescription: "J&B Lodge offers charming self-catering accommodation in Underberg, South Africa. Enjoy mountain views, fully equipped kitchen, and peaceful surroundings just 1km outside Underberg.",
  defaultKeywords: "J&B Lodge, Underberg accommodation, self-catering, South Africa, mountain views, Hodgson's Peaks, Sani Pass, KwaZulu-Natal, holiday rental, vacation rental",
  defaultImage: "/images/hero-image.jpg"
};

// API configuration
export const API_CONFIG = {
  contentUrl: "https://nightsbridge-api-call.alldigital.workers.dev/content/18993",
  availgridUrl: "https://nightsbridge-api-call.alldigital.workers.dev/availability",
  apiKey: "371",
  secret: "lwmagi"
};

// OpenWeatherMap API configuration
export const WEATHER_CONFIG = {
  apiKey: "2621cd36ef0ca648a62bb187be2854bf", // Replace with your actual API key from OpenWeatherMap
  baseUrl: "https://api.openweathermap.org/data/2.5",
  city: "Underberg",
  countryCode: "ZA",
  units: "metric" // Use metric units (Celsius, km/h)
}; 